import { createFileRoute } from '@tanstack/react-router'
import { TasksManagement } from '../../../components/AdminTasks'

export const Route = createFileRoute('/admin/tasks/')({
  component: () => <TasksManagement />,
})
